import SkinuvitaSeoHead from "../components/LandingPage/SkinuvitaSeoHead"
import SText from "../components/Text/SText"
import styles from "../../styles/LandingPage/privacy.module.scss"
import NavBarPatients from "./LandingPage/navbars/NavBarPatients"
import SkinuvitaDrawer from "../components/drawer/skinuvita_drawer"
import { useState } from "react"

export const LegalHeadline = ({ children }) => (
  <SText className={styles.headlineMargin} variant={"headlineLarge"}>
    {children}
  </SText>
)
export const LegalBodyText = ({ children }) => (
  <SText className={styles.bodyMargin} variant={"body"}>
    {children}
  </SText>
)
const LegalPageLayout = ({ headTitle, headDescription, canonicalPath = undefined, children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <>
      <SkinuvitaSeoHead title={headTitle} description={headDescription} canonicalPath={canonicalPath} />
      <NavBarPatients scrollLinksDisabled={true} />

      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.navBarSpacer}></div>
          {children}
        </div>
      </div>

      <SkinuvitaDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </>
  )
}

export default LegalPageLayout
